define([
    'underscore',
    'edge/platform/base/BaseCtrl',
    'edge/quoteandbind/common/models/Person',
], (_, BaseCtrl, Person) => {

    const fn = function ($scope, $stateParams, ViewModelService, $filter, MFPService, BASLER_QUESTIONSET_CONFIG, DTO_CLASSES, submissionViewModel, StateUtils, $timeout, ModalService, BaslerService, MFP_VEHICLE_CONSTANTS, ContextService, LoggingService, BaslerLoggingConstants) {

        const ctrl = Object.create(BaseCtrl);

        ctrl.init = init;
        ctrl.next = next;
        ctrl.createAdditionalVehicle = createAdditionalVehicle;
        ctrl.removeMainDriver = removeMainDriver;
        ctrl.removeAdditionalVehicle = removeAdditionalVehicle;
        ctrl.showToggleVariousDriver = showToggleVariousDriver;
        ctrl.hasAtLeastOneDeliveryVan = hasAtLeastOneDeliveryVan;
        ctrl.isAllowedContactTypeChange = isAllowedContactTypeChange;
        ctrl.showAdditionalContactToggler = showAdditionalContactToggler;
        ctrl.showAdditionalContactDialog = showAdditionalContactDialog;
        ctrl.showPartnerDetails = showPartnerDetails;
        ctrl.initTermTypeForPartnerLeasingContext = initTermTypeForPartnerLeasingContext;
        ctrl.isPartnerLeasingProduct = ContextService.isPartnerLeasingProduct;

        function init() {
            $scope.today = new Date();

            $scope.maxPeriodStartDate = new Date();
            $scope.maxPeriodStartDate.setUTCFullYear($scope.maxPeriodStartDate.getUTCFullYear() + 1);

            const submissionVm = submissionViewModel();
            const submission = submissionVm.value;
            $scope.quoteandbind = {
                submission: submission,
                submissionView: submissionVm,
            };

            $scope.quoteandbind.submission.draftData.dataProcessingConfirmed = true;

            const mfpLine = $scope.quoteandbind.submission.draftData.lobs.mFPLine;
            if (!mfpLine) {
                const {productCode, subproductInputParam} = $scope.quoteandbind.submission.draftData;
                throw new Error(`no mfpLine found. This can happen if url parameter 'product' is incorrect (productCode: ${productCode}, subproductInputParam: ${subproductInputParam})`);
            }
            $scope.draftDataView = $scope.quoteandbind.submissionView.draftData;
            initTermTypeForPartnerLeasingContext(ctrl.isPartnerLeasingProduct, $scope);

            //As we enter into the screen, we would like to have a main vehicle
            if (!mfpLine.hasVehicles()) {
                mfpLine.createVehicle(true);
            }

            initializeVehicles();

            $scope.accountHolderContactView = $scope.quoteandbind.submissionView.draftData.accountHolder.contact;

            //MFP line specific: very special hardcoded questions asked and must be answered before quoting
            if (!mfpLine.hasPreQualQuestionSets()) {
                mfpLine.initMinimumRiskDataQuestionSets();
            }

            $scope.questionSets = $scope.quoteandbind.submission.draftData.lobs.mFPLine.preQualQuestionSets;
            $scope.questionSetsConfig = BASLER_QUESTIONSET_CONFIG.createPreQuoteConfig($scope.quoteandbind.submission);

            // For the scenario when we have a main driver different from the account holder, we have to
            // create a new person.
            // When in a rollback, we have to check if already exists an additional driver
            // After that, a new view should be also created in order to manage the metadata beyond
            let additionalPerson;

            //note: object here is needed to be able to pass value by a reference not just copy value in subsequent directives
            $scope.accountHolderIsMainDriver = {value: true};

            if (mfpLine.hasDrivers() &&
                mfpLine.drivers[0].person.publicID !== $scope.accountHolderContactView.value.publicID) {
                additionalPerson = mfpLine.drivers[0].person;
                $scope.accountHolderIsMainDriver.value = false;
            } else {
                additionalPerson = new Person({isCompany: false, primaryAddress: {}});
                $scope.accountHolderIsMainDriver.value = true;
            }

            $scope.additionalPersonView = ViewModelService.create(additionalPerson, 'pc', DTO_CLASSES.BASLER_CONTACT_DTO, {isAccountHolder: false});

            if ($stateParams.retrievedByLink && !BaslerService.isNotExpiredQuote(submission.draftData.periodStartDate, true)) {
                //when quote is retrieved by link AND policy start date is in the past - warn customer with a popup
                const title = $filter('translate')('quoteandbind.mfp.directives.templates.mfp-risk-relevant-data.PeriodStartDateInPast.Title');
                const message = $filter('translate')('quoteandbind.mfp.directives.templates.mfp-risk-relevant-data.PeriodStartDateInPast.Message');
                const modalInstance = ModalService.showError(title, message);
                modalInstance.result.then(() => next($scope.form));
            }

            const {primaryAddress} = submission.draftData.accountHolder.contact;
            if (ContextService.isPartnerProduct()) {
                if ((primaryAddress.city === null && primaryAddress.postalCode) || !submission.draftData.lobs.mFPLine.driverCitySet(submission)) {
                    // city name is not set. The customer therefore has to enter it on the first page.
                    const title = $filter('translate')('quoteandbind.mfp.directives.templates.mfp-risk-relevant-data.CityNotSet.Title');
                    const message = $filter('translate')('quoteandbind.mfp.directives.templates.mfp-risk-relevant-data.CityNotSet.Message');
                    const modalInstance = ModalService.showError(title, message);
                    modalInstance.result.then(() => next($scope.form));
                }
                $scope.brandCode = $scope.quoteandbind.submission.draftData.brandCode || $scope.quoteandbind.submission.draftData.subproductInputParam;
            }
            $scope.insuranceStartDateKey = `quoteandbind.mfp.views.mfp-risk-relevant-data.${ContextService.isPartnerLeasingProduct() ? 'LeasingStartDate' : 'InsuranceStartDate'}`;

        }

        function initTermTypeForPartnerLeasingContext(isPartnerLeasingProduct, scope) {

            if (isPartnerLeasingProduct) {
                try {
                    const termTypeValue = _.find(scope.draftDataView.termType.aspects.availableValues, {code: 'MonthlyFixedDuration'});
                    if (termTypeValue) {
                        scope.draftDataView.termType.value = termTypeValue;
                    }
                } catch (err) {
                    // do nothing
                }
            }
        }

        /*
         * Function to display UWIssues that shall not redirect to contact us page.
         * Watch changes in submissionViewModel(), that it's modified by Flow API
         */
        $scope.$watch(submissionViewModel, () => MFPService.showUWPopupIfNeeded(submissionViewModel()));

        // Save the submission, quote it and forward to the quoting page
        function next(form) {

            form.submitted = true;
            if (!form.valid) {

                //Scroll to first field with error
                const scroll = function () {
                    if ($('.gw-error-inline').length > 0) {
                        $('html, body').animate(
                            {scrollTop: $('.gw-error-inline').offset().top - 60}

                            , 1000
                        );
                    }
                };
                $timeout(scroll);

                //stay on current page
                return;
            }

            setVariousDrivers();

            if ($scope.accountHolderContactView.isCompany.value) { //NOSONAR - do not change due better readability
                //if vehicle has various drivers, then remove all drivers
                if ($scope.mainVehicle.hasVariousDrivers.value) {
                    removeMainDriver();
                }
                //if acc.holder is company, then driver must be a person
                else {
                    setAdditionalPersonAsMainDriver(); //NOSONAR
                }

            } else if ($scope.accountHolderIsMainDriver.value) { //NOSONAR
                //acc.holder is at the same time and a driver
                setAccountHolderAsMainDriver(); //NOSONAR
            } else { //NOSONAR
                //backup case/plan
                setAdditionalPersonAsMainDriver(); //NOSONAR
            }
            [$scope.mainVehicle, $scope.additionalVehicle]
                .filter(vehicle => vehicle && !MFPService.showParkingOverNight(vehicle))
                .forEach((v) => {
                    v.parkingOvernight.value = undefined;
                });

            //set payment method to default value 'annual'
            if (!$scope.quoteandbind.submissionView.draftData.paymentMethod.value) {
                $scope.quoteandbind.submissionView.draftData.paymentMethod.value = 'annual';
            }

            LoggingService.logInfo(BaslerLoggingConstants.CHANGEPAGE);

            const {flowModel} = StateUtils.activeDataForState(true);
            return flowModel.next($scope.quoteandbind.submissionView);
        }

        function isAllowedContactTypeChange() {
            return !$scope.quoteandbind.submission.submissionExists();
        }

        function showAdditionalContactToggler() {
            return $scope.quoteandbind.submission.draftData.accountHolder.contact.isCompany === false;
        }

        function showPartnerDetails() {
            return _.isObject($scope.quoteandbind.submission.draftData.partnerDetails);
        }

        function showAdditionalContactDialog() {
            return ($scope.quoteandbind.submission.draftData.accountHolder.contact.isCompany === true && !ContextService.isPartnerLeasingProduct()) ||
                ($scope.quoteandbind.submission.draftData.accountHolder.contact.isCompany === true && $scope.mainVehicle.hasVariousDrivers.value === false) ||
                ($scope.quoteandbind.submission.draftData.accountHolder.contact.isCompany !== true && $scope.accountHolderIsMainDriver.value === false);
        }

        function initializeVehicles() {
            $scope.mainVehicle = _.find($scope.draftDataView.lobs.mFPLine.vehicles.children, (v) => {
                return (v.value.vehicleNumber === MFP_VEHICLE_CONSTANTS.MAIN_VEHICLE_NUMBER);
            });
            $scope.additionalVehicle = _.find($scope.draftDataView.lobs.mFPLine.vehicles.children, (v) => {
                return (v.value.vehicleNumber === MFP_VEHICLE_CONSTANTS.ADDITIONAL_VEHICLE_NUMBER);
            });
        }

        /*
         * Function to set the account holder (must be person) as the main driver
         */
        function setAccountHolderAsMainDriver() {
            $scope.quoteandbind.submission.draftData.lobs.mFPLine.createOrUpdateMainDriver($scope.accountHolderContactView.value);
            $scope.quoteandbind.submission.removeAnyOtherPerson($scope.accountHolderContactView.value);
        }

        function showToggleVariousDriver() {
            return $scope.accountHolderContactView.isCompany.value === true && ContextService.isPartnerLeasingProduct()
        }

        /*
         * Function to set an additional person as the main driver
         */
        function setAdditionalPersonAsMainDriver() {
            // else, the additional driver shall be created as a person in the submission
            const newPerson = $scope.quoteandbind.submission.createOrUpdatePerson($scope.additionalPersonView.value);
            $scope.quoteandbind.submission.draftData.lobs.mFPLine.createOrUpdateMainDriver(newPerson);
        }

        function removeMainDriver() {
            $scope.quoteandbind.submission.draftData.lobs.mFPLine.removeAllDrivers();
        }

        function setVariousDrivers() {
            $scope.mainVehicle.hasVariousDrivers.value = $scope.accountHolderContactView.isCompany.value && $scope.mainVehicle.hasVariousDrivers.value
        }

        function createAdditionalVehicle() {
            if ($scope.additionalVehicle) {
                throw Error('additional vehicle already exists');
            }
            const lob = $scope.quoteandbind.submission.draftData.lobs.mFPLine;
            const newVehicle = lob.createVehicle(false);
            $scope.additionalVehicle = $scope.quoteandbind.submissionView.draftData.lobs.mFPLine.vehicles.findFirstElement(newVehicle);
        }

        function removeAdditionalVehicle() {
            if (!$scope.additionalVehicle) {
                return;
            }
            const lob = $scope.quoteandbind.submission.draftData.lobs.mFPLine;
            lob.removeVehicle($scope.additionalVehicle.value);
            initializeVehicles();
            $scope.additionalVehicle = undefined;
        }

        // Test if one of both selected cars is a delivery van
        // A delivery van has a typeCertificateNumber starting with '3'
        function hasAtLeastOneDeliveryVan() {
            return MFPService.hasAtLeastOneDeliveryVan($scope.mainVehicle, $scope.additionalVehicle);
        }

        return ctrl.create($scope);
    };

    fn.$inject = ['$scope', '$stateParams', 'ViewModelService', '$filter', 'MFPService', 'BASLER_QUESTIONSET_CONFIG', 'DTO_CLASSES', 'submissionViewModel', 'StateUtils', '$timeout', 'ModalService', 'BaslerCommonService', 'MFP_VEHICLE_CONSTANTS', 'ContextService', 'LoggingService', 'BaslerLoggingConstants'];

    return fn;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/controllers/MFPRiskRelevantDataCtrl.js